import WalletModule from './views/Module.vue';
import Deposit from './views/Deposit.vue';
import Withdrawal from './views/Withdrawal.vue';
import Transaction from './views/Transaction.vue';
import TransactionDetails from './views/TransactionDetails.vue';
const WalletRoutes = {
    path: '/',
    component: WalletModule,
    children: [
      {
        path: 'deposit', 
        name: 'wallet-deposit',
        component: Deposit,
      },
      {
        path: 'withdrawal', 
        name: 'wallet-withdrawal',
        component: Withdrawal,
      },
      {
        path: 'transaction', 
        name: 'wallet-transaction',
        component: Transaction,
      },
       {
            path: 'transaction-details/:id',
            name: 'TransactionDetails',
            component: TransactionDetails
        },
    ],
};

export default WalletRoutes;